/**
 * 信息面板
 * Bai.Zhiming
 * 2019-7-23
 */
angular.module("infoPanelModule", [
    'c2cInfoPanelModule',
    'groupInfoPanelModule'
]).
directive("infoPanel", [function() {
    return {
        restrict: "E",
        replace: true,
        scope: {
            selectedInfo: '=',
            loginInfo: '=',
            fn: '='
        },
        templateUrl: './IM/chatWindow/infoPanel/infoPanel_tpl.html',
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    c2cInfoPanelLoad: true,
                    c2cInfoPanelShow: true,
                    groupInfoPanelLoad: false,
                    groupInfoPanelShow: false,
                };
                scope.data = {};
                scope.$watch("selectedInfo", (newV, oldV) => {
                    if (!newV) return;
                    if (newV == "groupNoSelected") {
                        scope.status.groupInfoPanelLoad = true;
                        scope.status.groupInfoPanelShow = true;
                        scope.status.c2cInfoPanelShow = false;
                        scope.status.groupInfo = "";
                        return;
                    }
                    if (newV.GroupId) {
                        scope.status.groupInfoPanelLoad = true;
                        scope.status.groupInfoPanelShow = true;
                        scope.status.c2cInfoPanelShow = false;
                        scope.status.groupInfo = newV;
                    } else {
                        scope.status.c2cInfoPanelLoad = true;
                        scope.status.c2cInfoPanelShow = true;
                        scope.status.groupInfoPanelShow = false;
                        scope.status.c2cInfo = newV;
                    }
                });
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {}
        }
    }
}])